<template>
  <mdb-modal removeBackdrop size="md" :show="modalShow" @close="handleClose">
    <mdb-modal-header class="text-center" color="indigo">
      <mdb-modal-title tag="h4" bold class="w-100 text-white">{{ title }}</mdb-modal-title>
    </mdb-modal-header>
    <mdb-modal-body class="mx-3" color="white"
      >{{ description }}
      <mdb-input
        :label="$t('manage_access_code_modal_input_name')"
        type="text"
        v-model="localProductCode.name"
      />
      <mdb-input
        :label="$t('manage_access_code_modal_input_amount')"
        :disabled="!this.isNewPatch()"
        type="number"
        :max="100000"
        v-model="localProductCode.count"
      />
      <DatePicker :date="localProductCode.validfrom" :label="$t('manage_access_code_modal_input_start')" v-on:date="validFrom"/>
      <DatePicker :date="localProductCode.validto" :label="$t('manage_access_code_modal_input_end')" v-on:date="validTo"/>
      <mdb-input
          v-model="invalidated"
          type="checkbox"
          id="checkBoxInvalidated"
          :label="$t('manage_access_code_modal_input_invalidated')"
        />
    </mdb-modal-body>
    <mdb-modal-footer center>
      <mdb-btn @click="modifyPatch" color="indigo"
        >{{ $t("save") }}<mdb-icon icon="paper-plane" class="ml-1"
      /></mdb-btn>
    </mdb-modal-footer>
  </mdb-modal>
</template>

<script>
import {
  mdbBtn,
  mdbModal,
  mdbModalHeader,
  mdbModalBody,
  mdbInput,
  mdbModalFooter,
  mdbModalTitle,
  mdbIcon
} from "mdbvue";
import DatePicker from './DatePicker.vue';
export default {
  name: "EditProductCodePatch",
  props: {
    modalShow: Boolean,
    title: String,
    description: String,
    productCode: Object
  },
  components: {
    mdbBtn,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbInput,
    mdbModalFooter,
    mdbModalTitle,
    mdbIcon,
    DatePicker
  },
  data() {
    return {
      createproductcodepath: "/1.0/front/password/addpatch",
      saveproductcodepath: "/1.0/front/password/updatepatch",
      localProductCode: this.productCode,
    };
  },
  mounted() {
    if (this.isNewPatch()) {
      console.log("");
    } else {
      console.log("");
    }
  },
  methods: {
    validTo(val) {
      this.localProductCode.validto = val;
    },
    validFrom(val) {
      this.localProductCode.validfrom = val;
    },
    isNewPatch() {
      return this.localProductCode.patchid === undefined;
    },
    modifyPatch() {
      if (this.productCode.id === undefined) this.createPatch();
      else this.savePatch();
    },
    handleClose() {
      console.log("modal hide");
      this.$emit("modal-cancelled");
    },
    createPatch() {
      this.postData = {
        sessionid: this.$store.getters.getToken,
        name: this.localProductCode.name,
        validfrom: this.localProductCode.validfrom,
        validto: this.localProductCode.validto,
        amount: this.localProductCode.count,
        invalidated: this.localProductCode.invalidated
      };
      this.$http
        .post(this.createproductcodepath, JSON.stringify(this.postData))
        .then(response => {
          if (response.status == 200) {
            this.$notify.success({
              message: this.$t("import_access_codes_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort
            });
            this.$emit("modal-ok");
          }
        })
        .catch(error => {
          this.$notify.error({
            message: this.$t("import_access_codes_not_success"),
            position: "top right",
            timeOut: this.$store.state.notifytimeoutshort
          });
          console.log(error);
        });
    },
    savePatch() {
      this.postData = {
        sessionid: this.$store.getters.getToken,
        name: this.localProductCode.name,
        validfrom: this.localProductCode.validfrom.split(" ")[0],
        validto: this.localProductCode.validto.split(" ")[0],
        patchid: this.localProductCode.id,
        invalidated: this.localProductCode.invalidated
      };
      this.$http
        .post(this.saveproductcodepath, JSON.stringify(this.postData))
        .then(response => {
          if (response.status == 200) {
            this.$notify.success({
              message: this.$t("import_access_codes_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort
            });
            this.$emit("modal-ok");
          }
        })
        .catch(error => {
          this.$notify.error({
            message: this.$t("import_access_codes_not_success"),
            position: "top right",
            timeOut: this.$store.state.notifytimeoutshort
          });
          console.log(error);
        });
    }
  },
  watch: {
    productCode() {
      this.localProductCode = this.productCode;
    },
  },
  computed: {
    invalidated: {
      // getter
      get: function() {
        return this.localProductCode.invalidated === 1 ? true : false;
      },
      // setter
      set: function(newValue) {
        this.localProductCode.invalidated = newValue ? 1 : 0;
      }
    },
  }
};
</script>

<style scoped></style>
